import { useEffect, useState } from 'react';
import { cn } from '../../../utils/utils';

interface ToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  className?: string;
}

export function Toggle({ enabled, onChange, className }: ToggleProps) {
  const [isEnabled, setIsEnabled] = useState(enabled);
  
  // Update internal state when prop changes
  useEffect(() => {
    setIsEnabled(enabled);
  }, [enabled]);

  const handleToggle = () => {
    const newState = !isEnabled;
    setIsEnabled(newState);
    onChange(newState);
  };

  return (
    <button
      type="button"
      className={cn(
        "relative inline-flex h-6 w-11 items-center rounded-full",
        isEnabled ? "bg-primary-600" : "bg-gray-200",
        className
      )}
      onClick={handleToggle}
      aria-pressed={isEnabled}
    >
      <span className="sr-only">Toggle</span>
      <span
        className={cn(
          "inline-block h-4 w-4 transform rounded-full bg-white transition",
          isEnabled ? "translate-x-6" : "translate-x-1"
        )}
      />
    </button>
  );
}